
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"-149.5 100.5 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M265.198 252.2C253.5 257.4 241 260.9 227.8 262.4c13.398-8.1 23.8-20.8 28.601-36a129.206 129.206 0 01-41.3 15.8c-11.902-12.6-28.802-20.6-47.502-20.6-42 0-72.899 39.2-63.399 79.9-54.101-2.7-102.1-28.601-134.199-68-17 29.2-8.801 67.5 20.1 86.9-10.7-.3-20.7-3.3-29.5-8.1-.7 30.2 20.9 58.399 52.2 64.6C3.6 379.399-6.4 380-16.6 378c8.3 25.899 32.3 44.699 60.8 45.199-27.398 21.4-61.8 31-96.398 27 28.8 18.5 63 29.2 99.8 29.2 120.799 0 189.1-102.1 185-193.6 12.897-9.1 23.897-20.499 32.596-33.599z"}})])
          )
        }
      }
    